import { ReactNode } from 'react';
import authClient from './authClient';

// Account app URL - where users go to login
const ACCOUNT_APP_URL = import.meta.env.VITE_ACCOUNT_URL || 'https://news-assist-account.kardoe.workers.dev';

interface AuthGuardProps {
  children: ReactNode;
}

function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return <LoadingSpinner />;
  }

  if (!session) {
    // Redirect to account app login with return URL
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${ACCOUNT_APP_URL}/login?returnTo=${returnUrl}`;
    return <LoadingSpinner />;
  }

  return <>{children}</>;
}
